






















import {Component, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import {cloneDeep} from 'lodash';
import PlanEditResultEdit from './PlanEditResultEdit.vue';
import CTextField from '@/components/base/textField/CTextField.vue';
import defaultConfig from '@/configs/PlanEditResultConfig';
import {mapMutations} from 'vuex';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';

@Component({
    components: {CEditDialog, CTextField, PlanEditResultEdit},
    methods: {
        ...mapMutations('planEditResult', ['setIsEditing']),
    },
})
export default class PlanEditResultConfigFlexGridEditDialog extends Mixins(EditDialogMixin) {
    public setIsEditing!: Function;

    init(data: {Value: string; Name: string; Id: null | number}) {
        this.data = data;
        if (this.options.type === 'add') {
            this.data.Value = cloneDeep(defaultConfig);
        } else {
            this.data.Value = JSON.parse(data.Value);
        }
    }
    save() {
        const form = this.$refs.form as any;
        if (!form) {
            console.warn('form ref not found at validation state');
        }
        this.valid = form.validate() && (this.$refs.resultEdit as any).getFormRef().validate();
        if (this.valid) {
            if (typeof this.options.saveCallback == 'function') {
                this.saving = true;
                const data = cloneDeep(this.data);
                data.Value = JSON.stringify(data.Value);
                this.options.saveCallback(data);
            } else {
                console.warn('no saveCallback provided');
                this.close();
            }
        } else {
            this.$toasted.error(this.$t('Common.Messages.PlsFillInAllFields') as string, {
                icon: 'mdi-message-alert',
                position: 'top-left',
            });
        }
    }

    beforeOpen() {
        this.setIsEditing(true);
    }
    beforeClose() {
        this.setIsEditing(false);
    }
}
